/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type RiskChatSummary = {
  /**
   * The chat session ID.
   */
  chatId: string;
  /**
   * Title of the chat session.
   */
  chatTitle?: string | undefined;
  /**
   * Number of findings in this chat.
   */
  findingsCount: number;
  /**
   * When the most recent finding was detected.
   */
  latestDetected: Date;
  /**
   * The user who owns the chat session.
   */
  userId?: string | undefined;
};

/** @internal */
export const RiskChatSummary$inboundSchema: z.ZodMiniType<
  RiskChatSummary,
  unknown
> = z.pipe(
  z.object({
    chat_id: z.string(),
    chat_title: z.optional(z.string()),
    findings_count: z.int(),
    latest_detected: z.pipe(
      z.iso.datetime({ offset: true }),
      z.transform(v => new Date(v)),
    ),
    user_id: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      "chat_id": "chatId",
      "chat_title": "chatTitle",
      "findings_count": "findingsCount",
      "latest_detected": "latestDetected",
      "user_id": "userId",
    });
  }),
);

export function riskChatSummaryFromJSON(
  jsonString: string,
): SafeParseResult<RiskChatSummary, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => RiskChatSummary$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'RiskChatSummary' from JSON`,
  );
}
